import { MapSetup } from '@leverege/recovr-plugins'
import { OperatingHoursSetup } from '@leverege/recovr-plugins/lib/recovrGeneric/routes/index.js'
import RecovrGenericSetup from '@leverege/recovr-plugins/lib/recovrGeneric/PluginSetup.js'
import Pairing from '@leverege/api-ui-pairing'
import RingTagSetup from '@leverege/recovr-plugins/lib/r4k/actions/ringTag/PluginSetup.js'
import Routes from './routes/PluginSetup.js'

export default {
  install( molten ) {
    MapSetup.install( molten )
    Pairing.install( molten )
    Routes.install( molten )
    RecovrGenericSetup.install( molten )
    RingTagSetup.install( molten )
    OperatingHoursSetup.install( molten )
    // Custom ScanTextHandler for parsing QR codes with delimited serial numbers
    // Extracts the serial number (second element by default) from scanned value
    molten.addPlugin(
      'ScanTextHandler',
      {
        type : 'extractSerialNumber',
        handler : ( model, value ) => {
          if ( !value ) {
            return value
          }
          const delimiter = model?.delimiter ? new RegExp( model.delimiter ) : /[;,]/
          const index = model?.index ?? 1
          const parts = value.split( delimiter )
          // Only extract if we have the expected number of parts (6 or 8 for QR format)
          if ( parts.length === 6 || parts.length === 8 ) {
            const extracted = parts[index]?.trim() ?? value
            return extracted
          }
          // Return original value if not in expected QR format
          return value
        }
      }
    )
  }
}
